import { BatchStatus } from "react-migration/domains/sites/typings";
import zod from "zod";

const BatchStatusSchema = zod.enum([
  BatchStatus.Pending,
  BatchStatus.Failed,
  BatchStatus.Created,
  BatchStatus.Cancelled,
  BatchStatus.Sent,
  BatchStatus.Queued,
]);

export const letterBatchTableRecordSchema = zod.object({
  id: zod.string(),
  name: zod.string().nonempty("form.error.required"),
  status: BatchStatusSchema,
  created: zod.string(),
  updated: zod.string(),
  lettersCount: zod.number().int().nonnegative(),
  letterPdfs: zod
    .object({
      url: zod.string(),
      name: zod.string(),
    })
    .array(),
  price: zod.number().nonnegative(),
});

export type LetterBatchesTableRecordFormData = zod.infer<typeof letterBatchTableRecordSchema>;

// We don't use LetterBatchRecord type and use LetterBatch from types folder instead
// because zod creates union type for status instead of enum
